module.exports = __webpack_public_path__ + "img/phone2.06ff439a.png";